import React, { FC, useEffect, useState } from 'react';
import styles from './userBadge.module.scss';
import { default_user } from '@jat-med/assets';
import { useLocation, useNavigate } from 'react-router-dom';
import { RoutesEnum, userRoles } from '../../shared';
import { IUserBadge } from './userBadge.interface';
import { useAppSelector } from '../../hooks';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

export const UserBadge: FC<IUserBadge> = ({ handleLogoutRequest }) => {
 const { t } = useTranslation();
 const navigate = useNavigate();
 const { pathname } = useLocation();

 const [userPosition, setUserPosition] = useState('');

 const currentUser = useAppSelector(
  ({ userReducer }) => userReducer.currentUser,
 );

 const onEnter = () => {
  if (!pathname.includes(RoutesEnum.admin)) {
   navigate(`${RoutesEnum.admin}${RoutesEnum.patients}`);
  } else {
   navigate(`${RoutesEnum.initialRoute}`);
  }
 };

 const handleEnterUserProfile = () => {
  if (!pathname.includes(RoutesEnum.admin)) {
   navigate(`${RoutesEnum.admin}${RoutesEnum.profile}`);
  } else {
   navigate(`${RoutesEnum.initialRoute}`);
  }
 };

 useEffect(() => {
  if (currentUser?.role === userRoles.admin) {
   setUserPosition(t('userRolesLocales.admin'));
  }
  if (currentUser?.role === userRoles.doctor) {
   setUserPosition(t('userRolesLocales.doctor'));
  }
  if (currentUser?.role === userRoles.rehabilitator) {
   setUserPosition(t('userRolesLocales.rehabilitator'));
  }
  if (currentUser?.role === userRoles.patient) {
   setUserPosition('');
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
 }, [currentUser, i18next.resolvedLanguage]);

 return (
  <>
   <div className={styles.badge_wrap}>
    {currentUser?.role !== userRoles.patient ? (
     <div className={styles.badge_dropdown} onClick={onEnter}>
      {!pathname.includes(RoutesEnum.admin) ? (
       <>
        <svg
         version='1.1'
         id='Layer_1'
         xmlns='http://www.w3.org/2000/svg'
         xmlnsXlink='http://www.w3.org/1999/xlink'
         x='0px'
         y='0px'
         width='30px'
         height='22px'
         style={{ marginBottom: '5px' }}
         viewBox='0 0 88.363 122.879'
         enableBackground='new 0 0 88.363 122.879'
         xmlSpace='preserve'
        >
         <g>
          <path d='M42.078,64.589H3.118C1.396,64.589,0,63.179,0,61.439s1.396-3.149,3.118-3.149h38.958L29.405,43.778 c-1.137-1.298-1.017-3.281,0.268-4.429c1.285-1.148,3.248-1.027,4.385,0.271l17.238,19.742c1.059,1.208,1.027,3.009-0.02,4.179 L34.057,83.26c-1.137,1.298-3.1,1.419-4.385,0.271c-1.284-1.148-1.404-3.132-0.268-4.43L42.078,64.589L42.078,64.589z M47.434,122.786c-1.77,0.428-3.55-0.659-3.978-2.428s0.659-3.55,2.427-3.978c4.258-1.032,7.932-1.761,11.303-2.428 c15.99-3.168,24.566-4.866,24.566-27.147V34.258c0-20.817-9.068-22.512-24.086-25.318c-3.596-0.672-7.498-1.401-11.783-2.441 c-1.768-0.428-2.855-2.208-2.427-3.978c0.428-1.769,2.208-2.855,3.978-2.428c4.02,0.976,7.885,1.698,11.447,2.363 c18.383,3.436,29.482,5.51,29.482,31.801v52.548c0,27.705-10.443,29.773-29.912,33.63 C54.986,121.121,51.215,121.869,47.434,122.786L47.434,122.786z' />
         </g>
        </svg>
        {t('navigation.goToCabinet')}
       </>
      ) : (
       <>
        <svg
         version='1.1'
         id='Layer_1'
         xmlns='http://www.w3.org/2000/svg'
         xmlnsXlink='http://www.w3.org/1999/xlink'
         x='0px'
         y='0px'
         height='22px'
         style={{ marginBottom: '5px' }}
         viewBox='0 0 89.149 122.88'
         enableBackground='new 0 0 89.149 122.88'
         xmlSpace='preserve'
        >
         <g>
          <path d='M79.128,64.598H40.069c-1.726,0-3.125-1.414-3.125-3.157c0-1.744,1.399-3.158,3.125-3.158h39.057L66.422,43.733 c-1.14-1.301-1.019-3.289,0.269-4.439c1.288-1.151,3.257-1.03,4.396,0.271l17.281,19.792c1.061,1.211,1.029,3.019-0.02,4.19 l-17.262,19.77c-1.14,1.302-3.108,1.423-4.396,0.271c-1.287-1.151-1.408-3.139-0.269-4.44L79.128,64.598L79.128,64.598z M42.396,116.674c1.689,0.409,2.727,2.11,2.318,3.799c-0.409,1.689-2.109,2.728-3.799,2.318c-3.801-0.922-7.582-1.671-11.052-2.358 C10.426,116.583,0,114.519,0,86.871V34.188C0,7.96,11.08,5.889,29.431,2.46c3.572-0.667,7.448-1.391,11.484-2.371 c1.689-0.409,3.39,0.629,3.799,2.319c0.408,1.689-0.629,3.39-2.318,3.799c-4.291,1.041-8.201,1.771-11.805,2.445 C15.454,11.48,6.315,13.188,6.315,34.188v52.683c0,22.467,8.643,24.179,24.756,27.37C34.453,114.911,38.138,115.642,42.396,116.674 L42.396,116.674z' />
         </g>
        </svg>
        {t('navigation.outOfCabinet')}
       </>
      )}
     </div>
    ) : (
     <div className={styles.badge_dropdown} onClick={handleEnterUserProfile}>
      {!pathname.includes(RoutesEnum.admin) ? (
       <>
        <svg
         version='1.1'
         id='Layer_1'
         xmlns='http://www.w3.org/2000/svg'
         xmlnsXlink='http://www.w3.org/1999/xlink'
         x='0px'
         y='0px'
         width='30px'
         height='22px'
         style={{ marginBottom: '5px' }}
         viewBox='0 0 88.363 122.879'
         enableBackground='new 0 0 88.363 122.879'
         xmlSpace='preserve'
        >
         <g>
          <path d='M42.078,64.589H3.118C1.396,64.589,0,63.179,0,61.439s1.396-3.149,3.118-3.149h38.958L29.405,43.778 c-1.137-1.298-1.017-3.281,0.268-4.429c1.285-1.148,3.248-1.027,4.385,0.271l17.238,19.742c1.059,1.208,1.027,3.009-0.02,4.179 L34.057,83.26c-1.137,1.298-3.1,1.419-4.385,0.271c-1.284-1.148-1.404-3.132-0.268-4.43L42.078,64.589L42.078,64.589z M47.434,122.786c-1.77,0.428-3.55-0.659-3.978-2.428s0.659-3.55,2.427-3.978c4.258-1.032,7.932-1.761,11.303-2.428 c15.99-3.168,24.566-4.866,24.566-27.147V34.258c0-20.817-9.068-22.512-24.086-25.318c-3.596-0.672-7.498-1.401-11.783-2.441 c-1.768-0.428-2.855-2.208-2.427-3.978c0.428-1.769,2.208-2.855,3.978-2.428c4.02,0.976,7.885,1.698,11.447,2.363 c18.383,3.436,29.482,5.51,29.482,31.801v52.548c0,27.705-10.443,29.773-29.912,33.63 C54.986,121.121,51.215,121.869,47.434,122.786L47.434,122.786z' />
         </g>
        </svg>
        {t('navigation.goToCabinet')}
       </>
      ) : (
       <>
        <svg
         version='1.1'
         id='Layer_1'
         xmlns='http://www.w3.org/2000/svg'
         xmlnsXlink='http://www.w3.org/1999/xlink'
         x='0px'
         y='0px'
         height='22px'
         style={{ marginBottom: '5px' }}
         viewBox='0 0 89.149 122.88'
         enableBackground='new 0 0 89.149 122.88'
         xmlSpace='preserve'
        >
         <g>
          <path d='M79.128,64.598H40.069c-1.726,0-3.125-1.414-3.125-3.157c0-1.744,1.399-3.158,3.125-3.158h39.057L66.422,43.733 c-1.14-1.301-1.019-3.289,0.269-4.439c1.288-1.151,3.257-1.03,4.396,0.271l17.281,19.792c1.061,1.211,1.029,3.019-0.02,4.19 l-17.262,19.77c-1.14,1.302-3.108,1.423-4.396,0.271c-1.287-1.151-1.408-3.139-0.269-4.44L79.128,64.598L79.128,64.598z M42.396,116.674c1.689,0.409,2.727,2.11,2.318,3.799c-0.409,1.689-2.109,2.728-3.799,2.318c-3.801-0.922-7.582-1.671-11.052-2.358 C10.426,116.583,0,114.519,0,86.871V34.188C0,7.96,11.08,5.889,29.431,2.46c3.572-0.667,7.448-1.391,11.484-2.371 c1.689-0.409,3.39,0.629,3.799,2.319c0.408,1.689-0.629,3.39-2.318,3.799c-4.291,1.041-8.201,1.771-11.805,2.445 C15.454,11.48,6.315,13.188,6.315,34.188v52.683c0,22.467,8.643,24.179,24.756,27.37C34.453,114.911,38.138,115.642,42.396,116.674 L42.396,116.674z' />
         </g>
        </svg>
        {t('navigation.outOfCabinet')}
       </>
      )}
     </div>
    )}
    <div className={styles.info_wrapp}>
     <div className={styles.info}>
      <p className={styles.name}>
       <span>{currentUser?.lastName || ''}</span>{' '}
       <span>{currentUser?.firstName || ''}</span>
      </p>

      <span className={styles.position}>{userPosition}</span>
     </div>
     <img src={currentUser?.photoLink || default_user} alt='avatar' />
    </div>
    <div
     className={styles.badge_dropdown}
     onClick={() => {
      handleLogoutRequest();
      navigate(RoutesEnum.initialRoute);
     }}
    >
     <svg
      width='24px'
      height='24px'
      viewBox='0 0 24 24'
      version='1.1'
      style={{ marginBottom: '2px' }}
      xmlns='http://www.w3.org/2000/svg'
     >
      <g
       id='Iconly/Broken/Logout'
       stroke='none'
       strokeWidth='1'
       fill='none'
       fillRule='evenodd'
      >
       <g
        id='Logout'
        transform='translate(2.000000, 2.500000)'
        fill='#000000'
        fillRule='nonzero'
       >
        <path d='M12.6483839,13.1601164 C13.0623027,13.1601164 13.3983073,13.4878795 13.3983073,13.8916457 L13.3983073,13.8916457 L13.3983073,14.7856314 C13.3983073,17.1094244 11.4601935,19 9.07699529,19 L9.07699529,19 L4.33007737,19 C1.94298343,19 3.01980663e-14,17.1046742 3.01980663e-14,14.775181 C3.01980663e-14,14.3714149 0.336004654,14.0446018 0.749923431,14.0446018 C1.16384221,14.0446018 1.49984686,14.3714149 1.49984686,14.775181 C1.49984686,16.299042 2.76984706,17.5369415 4.33007737,17.5369415 L4.33007737,17.5369415 L9.07699529,17.5369415 C10.6333299,17.5369415 11.8984605,16.3028421 11.8984605,14.7856314 L11.8984605,14.7856314 L11.8984605,13.8916457 C11.8984605,13.4878795 12.2344651,13.1601164 12.6483839,13.1601164 Z M19.2498527,8.76771071 C19.5537178,8.76771071 19.8273912,8.94631785 19.9432884,9.22087884 C20.0591857,9.49448978 19.9939326,9.8099024 19.7796688,10.0189108 L19.7796688,10.0189108 L16.9338554,12.7825713 C16.7867925,12.924127 16.5959029,12.9963299 16.4040394,12.9963299 C16.2121759,12.9963299 16.0193384,12.924127 15.8732494,12.7806712 C15.5810715,12.4937598 15.5810715,12.0310912 15.8751973,11.7460798 L15.8751973,11.7460798 L17.4344537,10.2317193 L7.54909935,10.2317193 C7.13518057,10.2317193 6.79820199,9.90395616 6.79820199,9.50019001 C6.79820199,9.09642386 7.13518057,8.76771071 7.54909935,8.76771071 L7.54909935,8.76771071 Z M9.06745081,1.7408297e-13 C11.4555187,1.7408297e-13 13.3985021,1.89532581 13.3985021,4.22481899 L13.3985021,4.22481899 L13.3985021,5.10930437 C13.3985021,5.51212048 13.0624975,5.8398836 12.6485787,5.8398836 C12.2346599,5.8398836 11.8986552,5.51212048 11.8986552,5.10930437 L11.8986552,5.10930437 L11.8986552,4.22481899 C11.8986552,2.70095804 10.628655,1.46305852 9.06745081,1.46305852 L9.06745081,1.46305852 L4.32150681,1.46305852 C2.76517221,1.46305852 1.50004165,2.69810792 1.50004165,4.21436857 L1.50004165,4.21436857 L1.50004165,11.448908 C1.50004165,11.8526741 1.16403699,12.1804372 0.750118216,12.1804372 C0.336199439,12.1804372 0.000194785307,11.8526741 0.000194785307,11.448908 L0.000194785307,11.448908 L0.000194785307,4.21436857 C0.000194785307,1.89057562 1.93830859,1.7408297e-13 4.32150681,1.7408297e-13 L4.32150681,1.7408297e-13 Z M15.8713016,6.22265391 C16.1634795,5.93384235 16.6368078,5.93194228 16.9319076,6.21695368 L16.9319076,6.21695368 L17.6487175,6.90858134 C17.9438172,7.19359274 17.9457651,7.65626125 17.6545611,7.94317273 C17.5074982,8.0875785 17.3146607,8.16073143 17.1218232,8.16073143 C16.9309336,8.16073143 16.740044,8.08947858 16.5939551,7.94887295 L16.5939551,7.94887295 L15.8761712,7.25629525 C15.5820454,6.97223389 15.5800975,6.50861534 15.8713016,6.22265391 Z'></path>
       </g>
      </g>
     </svg>
     {t('navigation.exit')}
    </div>
   </div>
  </>
 );
};
